const storeCode = process.env.VUE_APP_STORE_CODE;
const contextCode = process.env.VUE_APP_CONTEXT;

// ---------- IMPORT --------

// filters
import Vue from "vue";
import Vuex from 'vuex'
import truncate from "./filters/truncate.js";
import formatNumber from "./filters/formatNumber.js";
import formatPrice from "./filters/formatPrice.js";
import formatDate from "./filters/formatDate.js";
import formatDateIntervention from "./filters/formatDateIntervention.js";
import formatVideoThumbnail from "./filters/formatVideoThumbnail.js";
import formatVideoUrl from "./filters/formatVideoUrl.js";
import formatProductChoice from "./filters/formatProductChoice.js";

// lib
import VueGlobalVariable from "vue-global-var";
import ZoomOnHover from "vue-zoom-on-hover";
import "lazysizes";
import Dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
Dayjs.extend(utc);
import Vuelidate from "vuelidate";
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import SvgSprite from "vue-svg-sprite";
import VueSimpleAlert from "vue-simple-alert";

import storePlugin from './storePlugin'

// css
import Microtip from "microtip/microtip.css";

// ------------- USE --------------------

const messages = {
    required: "Le champ {attribute} est obligatoire",
    postalCode: "Le format du champ {attribute} n'est pas valide",
    postalCodeValidator: "Ce format n'est pas valide, ex: 67100",
    phone: "Le format du champ {attribute} n'est pas valides",
    sameAs: "Veuillez accepter les conditions d'utilisation",
    email: "Le format du champ {attribute} n'est pas valide",
    isOptinChecked: "Veuillez cocher la case",
    forbiddenCityValue: "Veuillez saisir une ville valide.",
    forbiddenAdressValue: "Veuillez saisir une adresse valide.",
};

// Filters
Vue.filter("truncate", truncate);
Vue.filter("formatPrice", formatPrice);
Vue.filter("formatNumber", formatNumber);
Vue.filter("formatDate", formatDate);
Vue.filter("formatDateIntervention", formatDateIntervention);
Vue.filter("formatVideoUrl", formatVideoUrl);
Vue.filter("formatVideoThumbnail", formatVideoThumbnail);
Vue.filter("formatProductChoice", formatProductChoice);

var pathSvg = '';
if(contextCode != '') {
    pathSvg = process.env.VUE_APP_API_BASE_URL+'/skin/frontend/api/assets/'+storeCode+'/svg/'+contextCode+'/sprite.svg';
}
else {
    pathSvg = process.env.VUE_APP_API_BASE_URL+'/skin/frontend/api/assets/'+storeCode+'/svg/sprite.svg';
}

// USE
Vue.use(VueSimpleAlert);
Vue.use(SvgSprite, {
    url: `${pathSvg}`,
});
Vue.config.productionTip = false;
Vue.config.devtools = true;

// Form Error
Vue.use(Vuelidate);
Vue.use(VuelidateErrorExtractor, {
    messages,
    template: templates.singleErrorExtractor.foundation6,
    attributes: {
        firstname: "Prénom",
        isPro: "Professionnel",
        email: "Email",
        lastname: "Nom de famille",
        postalcode: "Code postal",
        adresse: "Adresse",
        city: "Ville",
        country: "Pays",
        phone: "Téléphone",
        floor: "Etage supérieur",
        elevator: "Ascenseur",
        billingFirstname: "Prénom",
        billingLastname: "Nom de famille",
        billingAdresse: "Adresse",
        billingPostalcode: "Code postal",
        billingCity: "Ville",
        billingCountry: "Pays",
        billingPhone: "Téléphone",
        password: "Mot de passe",
        emailLogin: "Email",
        company: "Société",
        prefix: "Civilité",
    },
});

Vue.use(VueGlobalVariable, {
    globals: {},
});
Vue.use(ZoomOnHover);
Vue.use(Microtip);

if(!Vue.prototype.hasOwnProperty('$dayjs')) {
    Object.defineProperties(Vue.prototype, {
        $dayjs: {
            get() {
                return Dayjs;
            },
        }
    });
}

Vue.use(storePlugin);
Vue.use(Vuex);

// COMPONENTS
Vue.component("formWrapper", templates.FormWrapper);
